export const deepFreeze = (object) => {
    // Retrieve the property names defined on object
    const propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self

    for (const name of propNames) {
        const value = object[name];

        if (value && typeof value === "object") {
            deepFreeze(value);
        }
    }

    return Object.freeze(object);
};

export const deepSeal = (object) => {
    // Retrieve the property names defined on object
    const propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self

    for (const name of propNames) {
        const value = object[name];

        if (value && typeof value === "object") {
            deepSeal(value);
        }
    }

    return Object.seal(object);
};

export const arrayValues2ObjectKeys = (ar, val) => {
    return ar.reduce( (acc, unit) => ( acc[unit] = val, acc),{});
};

/**
 * @param {Array} ar Input array
 * @param {Function} fnKey function to produce key
 * @param {Function} fnVal function to produce value
 */
export const arrayValues2ObjectKeysFn = (ar,fnKey,  fnVal) => {
    return ar.reduce( (acc, obj) => ( acc[fnKey(obj)] = fnVal(obj), acc),{});
};

/**
 * @param {Array} objects Input array
 * @param {String} metaKey function to produce key
 * @param {Any} def function to produce key
 */
export const objects2UnitColors = (objects, metaKey, def) => {
    return objects.reduce( (acc, obj) => {
        const val = obj.meta[metaKey] || def;
        return setObjectKeyIfVal(acc, obj.unit.name, val);
    }, {});
};

export const setObjectKeyIfVal = (obj, key, val) => {
    if(val){
        obj[key] = val;
    }
    return obj;
};

export const routerPushHandler = (error) => {
    if (error.name !== "NavigationDuplicated") {
        throw error;
    }
}

export const queryParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});